import React from 'react'
import styled from 'styled-components'
import focusStyles from './focus.styles'

const apAtomName = {ap_atom_name: 'focusAtom'}
const Span = styled.span`
  ${focusStyles};
`

const FocusAtom = function ({...props}) {
  return <Span {...apAtomName}>{props.children}</Span>
}

export default FocusAtom
